import { useTranslation } from 'react-i18next';
import { routeMap } from '../routes/routeMap';

/**
 * Returns a function lp(routeKey, params?) that builds a localized path
 * with the current language prefix.
 *
 * Usage:
 *   const lp = useLocalizedPath();
 *   <Link to={lp('creditCards')}>...</Link>
 *   // → '/es/tarjetas-de-credito' or '/fr/cartes-de-credit'
 */
export function useLocalizedPath() {
  const { i18n } = useTranslation();
  const lng = i18n.language;

  return (routeKey, params) => {
    const paths = routeMap[routeKey];
    if (!paths) return `/${lng}/`;
    let path = `/${lng}${paths[lng]}`;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        path = path.replace(`:${k}`, v);
      });
    }
    return path;
  };
}
